import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2 } from "lucide-react";
import { bgWithImageStyle } from "../utils/themeBg";
import Header from "../components/leovera/Header";
import Footer from "../components/leovera/Footer";
import BundleCard from "../components/leovera/BundleCard";
import NotFound from "./NotFound";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const setMeta = (name, content, prop = false) => {
  const attr = prop ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

export default function BundlePage() {
  const { slug } = useParams();
  const [bundle, setBundle] = useState(null);
  const [catalog, setCatalog] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setBundle(null); setNotFound(false);
    window.scrollTo(0, 0);
    axios.get(`${API}/bundle/${slug}`).then(({ data }) => setBundle(data)).catch(() => setNotFound(true));
    axios.get(`${API}/catalog`).then(({ data }) => setCatalog(data || [])).catch(() => setCatalog([]));
  }, [slug]);

  const productsById = useMemo(() => {
    const map = {};
    (catalog || []).forEach((p) => { map[p.id] = p; });
    return map;
  }, [catalog]);

  useEffect(() => {
    if (!bundle) return;
    const title = `${bundle.name} | LEOVERA Nutrition`;
    document.title = title;
    setMeta("description", (bundle.description || "").slice(0, 160));
    setMeta("og:title", title, true);
    setMeta("og:description", (bundle.description || "").slice(0, 200), true);
    setMeta("og:image", bundle.image || "", true);
    setMeta("og:url", window.location.href, true);
    return () => { document.title = "LEOVERA Nutrition"; };
  }, [bundle]);

  if (notFound) return <NotFound />;
  if (!bundle || catalog === null) {
    return (
      <div className="min-h-screen bg-[var(--lv-bg,#060A14)] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-[#C0C0C0] animate-spin" />
      </div>
    );
  }

  const unavailable = (bundle.items || []).some((it) => !productsById[it.product_id]);

  return (
    <div className="min-h-screen text-white" style={bgWithImageStyle()} data-testid="bundle-page">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-24 pb-20">
        <Link to="/#kit" data-testid="bundle-page-back"
              className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#94A3B8] hover:text-white mb-8">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna alle offerte
        </Link>
        {unavailable ? (
          <p className="text-[#94A3B8]" data-testid="bundle-page-unavailable">
            Questa offerta non è al momento disponibile.
          </p>
        ) : (
          <BundleCard bundle={bundle} productsById={productsById} hideLink linkProducts />
        )}
      </main>
      <Footer />
    </div>
  );
}
